import { useEffect, useRef } from 'react';

import { useNotificationsContext } from '../notifications-context';

import { useToastStore } from '@/shared/feedback/api';

/**
 * Shows a toast when a new unread notification arrives via WebSocket.
 * Reads from NotificationsContext (React Query cache fed by useRealtimeNotifications)
 * so it reacts to live WS pushes, not just the initial REST fetch.
 */
export function useNotificationToasts() {
  const { notifications } = useNotificationsContext();
  const addToast = useToastStore(state => state.addToast);
  const lastIdRef = useRef<string | null>(null);

  useEffect(() => {
    const latest = notifications[0];
    if (!latest || latest.id === lastIdRef.current) return;

    lastIdRef.current = latest.id;

    if (!latest.read) {
      addToast({
        type: latest.type,
        title: latest.title,
        message: latest.message,
        duration: 5000,
      });
    }
  }, [notifications, addToast]);
}
